@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.placeholder {
  height: 100%;
  width: 100%;
}

.content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    margin-bottom: 10px;
  }
}

.title {
  font-size: 24px;
  line-height: 30px;
}

.button {
  margin-top: 35px;
}

.message {
  max-width: 65%;
  color: @display-grid--actionable-placeholder--text-color;
  font-size: 16px;
  text-align: center;
  line-height: 24px;
  padding: 10px;
}
